// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from 'react';
import { useRouter } from 'next/router';
import { PlasmicAvatar, DefaultAvatarProps } from './plasmic/fragment_design_system/PlasmicAvatar';
import { HTMLElementRefOf } from '@plasmicapp/react-web';

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface AvatarProps extends Omit<DefaultAvatarProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultAvatarProps altogether and have
// total control over the props for your component.
export interface AvatarProps extends DefaultAvatarProps {
  onImageError?: () => void;
}

function Avatar_(props: AvatarProps, ref: HTMLElementRefOf<'div'>) {
  const { onImageError, ...rest } = props;
  const router = useRouter();
  const isDoctorPage = router.pathname === '/dr/[slug]' || router.asPath.startsWith('/dr/');
  const isDoctorAvatar = isDoctorPage && typeof rest.alt === 'string' && rest.alt.startsWith('دکتر ');
  return (
    <PlasmicAvatar
      root={{ ref }}
      {...rest}
      img={{
        ...(isDoctorAvatar ? { loading: 'eager' as const, fetchPriority: 'high' as const } : {}),
        onError: onImageError,
      }}
    />
  );
}

const Avatar = React.forwardRef(Avatar_);
export default Avatar;
